import { CircleNotchIcon } from '@phosphor-icons/react';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

interface SpinnerProps extends Omit<ComponentProps<typeof CircleNotchIcon>, 'size'> {
  size?: 'sm' | 'default' | 'lg';
}

const sizeClasses = {
  sm: 'size-3.5',
  default: 'size-5',
  lg: 'size-8',
};

function Spinner({
  className,
  size = 'default',
  'aria-label': ariaLabel = 'Loading',
  ...props
}: SpinnerProps) {
  return (
    <CircleNotchIcon
      {...props}
      role="status"
      aria-label={ariaLabel}
      className={cn('animate-spin text-muted-foreground', sizeClasses[size], className)}
    />
  );
}

export { Spinner };
